module.exports = {"371581001":"青年路街道","371581002":"新华路街道","371581003":"先锋路街道","371581004":"大辛庄街道","371581101":"松林镇","371581102":"老赵庄镇","371581103":"康庄镇","371581104":"魏湾镇","371581105":"刘垓子镇","371581107":"八岔路镇","371581108":"潘庄镇","371581109":"烟店镇","371581110":"唐园镇","371581111":"金郝庄镇","371581112":"戴湾镇","371581113":"尚店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371581.json
// module id = 1492
// module chunks = 0